import React from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";

export default function ConfirmDialog({ open, handleClose, handleConfirm, title, message, newLineMessage, warningMessage = undefined }) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
                <br />
                {newLineMessage && (
                    <DialogContentText id="alert-dialog-description-newline">{newLineMessage}</DialogContentText>
                )}
                {warningMessage && (
                    <DialogContentText id="alert-dialog-description-warning" style={{ color: "orange", fontWeight: 600, marginTop: 8 }}>
                        ⚠ {warningMessage}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleConfirm} color="primary" autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}
